import { Video, Calendar, Users, Plus } from "lucide-react";
import { PageHeader } from "@/components/dashboard/ui";

export default function AdminVideo() {
  return (
    <div>
      <PageHeader title="Live Video Conferencing" subtitle="Host client consultations & album review calls inside PMR Events."
        action={<button className="inline-flex items-center gap-2 bg-gold text-black text-sm font-medium rounded-full px-5 py-2.5 opacity-70 cursor-not-allowed"><Plus className="w-4 h-4" /> New Meeting</button>} />
      <div className="rounded-2xl border border-gold/20 bg-gradient-to-b from-gold/5 to-transparent p-10 text-center">
        <div className="w-16 h-16 rounded-2xl bg-gold/15 flex items-center justify-center mx-auto mb-5"><Video className="w-8 h-8 text-gold" /></div>
        <h2 className="font-serif text-3xl text-white font-light">Coming soon</h2>
        <p className="text-muted-foreground mt-3 max-w-md mx-auto">Built-in HD video calls with screen-share for live album selection with your clients — no third-party tools needed.</p>
        <div className="grid sm:grid-cols-3 gap-4 mt-8 max-w-2xl mx-auto text-left">
          {[[Calendar, "Schedule calls", "Book review sessions with clients"], [Users, "Multi-participant", "Invite couples & families together"], [Video, "Live album review", "Select photos together in real time"]].map(([Icon, t, d]) => (
            <div key={t} className="rounded-xl border border-border bg-black/40 p-4"><Icon className="w-5 h-5 text-gold mb-2" /><div className="text-white text-sm font-medium">{t}</div><div className="text-xs text-muted-foreground mt-1">{d}</div></div>
          ))}
        </div>
      </div>
    </div>
  );
}
